export const parties = [
  { name: "CDU/CSU", match: "cdu/csu", color: "#262626" },
  { name: "SPD", match: "spd", color: "#FA0033" },
  { name: "AFD", match: "afd", color: "#0085FF" },
  { name: "FDP", match: "fdp", color: "#FFCB31" },
  { name: "Left", match: "linke", color: "#8374BE" },
  { name: "Green", match: "grüne", color: "#2ECB94" },
  { name: "Free Voters", match: "freie_wähler", color: "#0085FF", hideByDefault: true },
  { name: "SSW", match: "ssw", color: "#003990", hideByDefault: true },
  { name: "Other", match: "other", color: "#CCCCCC", hideByDefault: true }
];
